import useMiddlewareContext from './hooks/useMiddlewareContext';
import { removeTrailingSlash } from '@/utils/routes';
import { getLaunchDarklyFlag } from '@/utils/launchDarklyFlags';
import FeatureFlags from '@/constants/FeatureFlags';

export default async () => {
  const { currentUser, route, redirect } = useMiddlewareContext();

  const { role, _auth, _company } = currentUser;
  const { activation_status } = _auth;

  // Leads should go to payment page, not activation
  // Let non-paid middleware handle them
  if (_company?.status === 'lead') {
    return;
  }

  if (['created', 'email-sent'].includes(activation_status)) {
    // Allow access to these routes even if not activated
    if (
      ['/privacy/privacy', '/terms/terms', '/activate-account'].includes(
        removeTrailingSlash(route.path)
      )
    ) {
      return;
    }

    // Allow legacy employee-welcome flow for backwards compatibility
    if (route.path.includes('/employee-welcome/')) {
      return;
    }

    // Check if employee onboarding wizard feature is enabled
    const employeeOnboardingEnabled = await getLaunchDarklyFlag(
      FeatureFlags.H3_FLYWHEEL
    );

    // New flow: If employee onboarding wizard is enabled, use new Nuc activation
    // Legacy flow: If disabled, use old employee-welcome flow
    if (employeeOnboardingEnabled) {
      redirect('/activate-account');
    } else if (role === 'user') {
      // For legacy/existing companies without the feature flag
      // redirect non-owner roles to employee-welcome
      redirect('/activate-account');
    } else {
      redirect('/employee-welcome/');
    }
  }
};
